// extracted by mini-css-extract-plugin
export default {"page":"login_page__sFKv3","form":"login_form__fot6s","center":"login_center__-ryQG","textRow":"login_textRow__sDqug"};